module.exports = __webpack_public_path__ + "img/pic14.29e7c18b.png";